export const colors = {
  main: '#030f27',
  selectedMain: '#2F3031',
  mainLight: '#e3e3e3',
  mainLighter: '#f0f2f5',
  mainRed: '#e30613',
  borderColor: '#dacbcb',
  secondaryBorderColor: '#e9e9e9',
  gray: '#f0f2f5',
  white: '#ffffff',
  inValidFormColor: '#f5222d',
  arrowColor: '#fff',
  primaryFontColor: '#fff',
  colorContainerBcg: '#fff',
  drawerBackground: '#fff',
  selectArrow: '#000',
  borderDark: '#f0f2f5'
};

export const sider = {
  collapsedWidth: 80,
  width: window.innerWidth > 1150 ? 400 : '100%',
  transitionLength: 0.2
};
